// Angular imports
import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'input-field',
    templateUrl: './input-field.component.html',
    styleUrls: ['./input-field.component.scss'],
    standalone: false
})
export class InputFieldComponent implements OnInit {
    @ViewChild('field') public _inputElement!: ElementRef;

    @Input() public set value(v: string){
        // console.log('NEW VALUE', v);
        this._value = v;
    };

    @Input() public readonly: boolean = false;

    @Input() public title: string = '';
    @Input() public placeholder: string | null = null;
    @Input() public type: string = 'text';
    @Input() public showSpinner: boolean = false;


    @Output() public valueChange = new EventEmitter<string>();
    @Output() public focusLoss = new EventEmitter<string>();

    public _value: string | null = null;
    public _selected = false;

    constructor() { }

    public ngOnInit() {
        if (!this.placeholder)
            this.placeholder = this.title;
    }

    /**
     * Focuses the input's content
     * @returns void
     */
    public focus(): void {
        this._inputElement.nativeElement.focus();
    }

    /**
     * Blurs the input's content (if it has focus)
     * @returns void
     */
    public blur(): void {
        this._inputElement.nativeElement.blur();
    }

    /**
     * Selects the input's content
     * @returns void
     */
    public select(): void {
        this._inputElement.nativeElement.select();
    }

    /* --- Event handlers --- */

    public _handleFocus() {
        if (!this.readonly) return;

        this._selected = true;
    }

    public _handleBlur() {
        this._selected = false;
        this.focusLoss.emit(this._value ?? '');
    }

    public async _handleModelChange(val: string) {
        // If the value is the same, clear the current value
        if (val === this._value)
            await this.clearValue();

        // Assign the value
        this._value = val;

        // Emit change event
        this.valueChange.emit(this._value ?? '');
    }

    public _purgeEvent(event: Event) {
        event.stopPropagation();
    }

    private async clearValue() {
        this._value = this._value === null ? '' : null;
        return new Promise(resolve => {
            setTimeout(resolve, 0);
        });
    }
}
